<template>
  <div>
    <base-header class="pb-6 bg-light">
      <!-- Page header -->
      <b-row aling-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Location Check</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container>
      <b-row class="mt-4 align-items-start">
        <b-col cols="auto" sm="5">
          <b-card>
            <div>
              <b-row class="justify-content-center">
                <b-form @submit="submitSearch($event)">
                  <b-row class="align-items-center">
                    <b-col cols="4">
                      <p class="text-nowrap font-weight-600 p-0 ">Show results for all sims or search by one IMSI</p>
                    </b-col>
                  </b-row>
                  <b-row class="align-items-center">
                    <b-col cols="4">
                      <p class="text-nowrap font-weight-600 p-0 m-0">Time Interval:</p>
                    </b-col>
                    <b-col>
                      <b-form-select
                          id="search-option"
                          v-model="periodOption"
                          :options="periodOptions"
                          size="sm"
                      >
                      </b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3 d-flex align-items-center">
                    <b-col cols="4">
                      <p class="text-nowrap font-weight-600 p-0 m-0">IMSI:</p>
                    </b-col>
                    <b-col>
                      <b-form-input
                          id="imsi"
                          v-model="imsiSearch"
                          placeholder="Enter IMSI"
                          :state="imsiState"
                          type="number"
                          size="sm"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback>
                        IMSI must be 15 digits long
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col class="w-100 justify-content-end">
                      <b-button
                          v-if="loadingStatus"
                          block
                          class="mt-2"
                          variant="primary"
                          size="sm"
                          type="button"
                          disabled
                      >
                        <b-spinner variant="light" label="Loading..."></b-spinner>
                        Loading...
                      </b-button>
                      <b-button
                          v-else
                          block
                          class="mt-2"
                          variant="primary"
                          size="sm"
                          :loadingStatus="loadingStatus"
                          :disabled="loadingStatus || !imsiState"
                          @click="submitSearch($event)"
                          type="submit"
                      >
                        Search <i class="fa fa-search"></i>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-row>
            </div>
            <hr class="mb-0 p-0"/>
            <b-card-body v-if="isImeiData && !loadingStatus">
				<b-row class="mb-2">
					<b-col class="text-center">
						<h2>IMEI Data</h2>
					</b-col>
				</b-row>
				<b-table
					:items="lmeiData"
					class="text-center primary-table"
					thead-class="d-none"
					hover
					responsive
					show-empty
					small
					striped
				>
					<template #cell(field)="row">
						<span class="mb-0  font-weight-600">{{ row.item.field }}:</span>
					</template>
					<template #cell(value)="row">
						<span v-if="row.item.field == 'BANDS' && !showBands" class="mb-0 font-weight-600 cursor-pointer " @click="showBands = !showBands">Click to show</span>
						<span v-else class="mb-0 cursor-pointer" @click="showBands = !showBands">{{ row.item.value }}</span>
					</template>
				</b-table>
              <div v-if="loadingStatus">
                <div class="text-center w-100">
                  <p>Searching for location data on IMSI {{ imsi }}</p>
                  <b-icon
                      icon="three-dots"
                      class="text-center"
                      animation="cylon"
                      font-scale="4"
                  ></b-icon>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col class="bg-light p-1" style="height: 610px" v-if="mapLoading">
          <!-- Data Volume By Region Card (map) -->
          <div class="text-center w-100">
            <p v-if="mapLoading">Searching for location data on IMSI {{ imsi }}</p>
            <b-icon
                icon="three-dots"
                class="text-center"
                animation="cylon"
                font-scale="4"
                v-if="mapLoading"
            ></b-icon>
          </div>
        </b-col>
        <b-col class="bg-light p-1" style="height: 610px" :class="{'d-none': mapLoading}">
          <div id="map" class="map-canvas" style="height: 100%"></div>
        </b-col>
      </b-row>

      <b-row class="mt-4 justify-content-center">
        <b-col>
          <b-card id="locationTable">
            <b-card-header>
              <b-row v-if="locationCheckTableData.length > 0">
                <b-col cols="12" xl="8" lg="7" md="7" sm="6">
                  <b-form-group
                      label=""
                      label-for="per-page-select"
                      label-cols-sm="0"
                      label-cols-md="0"
                      label-cols-lg="0"
                      label-align-sm="center"
                      label-size="sm"
                      class="mb-2 per-page-select"
                  >
                    <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
                    <b-form-select
                        id="per-page-select"
                        class="diameter-report-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                        v-on:input="changePageOption(perPage)"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
                  <b-form-group
                      label=""
                      label-for="filter-input"
                      label-align-sm="right"
                      label-size="sm "
                      class="mb-0 per-page-select"
                  >
                    <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
                    <b-input-group size="sm">
                      <b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-header>
            <b-card-body>

              <b-table
                  v-if="!loadingStatus"
                  striped
                  hover
                  :items="locationCheckTableData"
                  :fields="locationCheckTableColumns"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  head-variant="light"
                  table-class="text-nowrap"
                  class="primary-table"
                  sticky-header
                  thead-class="white"
                  show-empty
                  responsive
                  small
                  @filtered="onFiltered"
              >
                <template #cell(imsi)="row">
                  <a
                      role="button"
                      @click="updateSelectedIMSI(row.item)"
                      title="Click on an IMSI to see it displayed on the map"
                      style="cursor: pointer"
                  >
                  <i class="fas fa-map-marker-alt"></i>
                    {{ row.item.imsi }}
                  </a>
                </template>
              </b-table>

              <div v-else class="text-center">
                <b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
              </div>

              <b-row v-if="locationCheckTableData.length > 0" class="mt-4">
                <b-col>
                  <p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
                </b-col>
                <b-col>
                  <b-pagination
                      class="flex-fill-custom pr-4 ml-3 justify-content-end"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      size="sm"
                  ></b-pagination>
                </b-col>
              </b-row>


            </b-card-body>
          </b-card>


        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import RouteBreadCrumb from "../../../components/Breadcrumb/RouteBreadcrumb";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import configDirective from "@/common/directive/config-directive";
import initService from "../../../common/api-services/init-service";
import searchDetailService from "../../../common/api-services/search-details-service";
import pagination from "@/common/format/pagination";

export default {
  name: "LocationCheck",
  components: {
    RouteBreadCrumb,
  },
  async mounted() {
    document.title = "Troubleshooting - Location Check";

    //don't do anything unless the user has access
    if (this.noAccess) {
      this.$router.push("/restricted").catch(() => {});
    }
  },
  computed: {
    noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
    searchDisabled() {
      return !(String(this.imsiSearch).length === 15);
    },
    imsiState() {
      return String(this.imsiSearch).length === 0 || String(this.imsiSearch).length === 15;
    },
  },
  data() {
    return {
      locationCheckTableData: [],
      locationCheckTableColumns: [
        {key: "mcc", label: "mcc", sortable: true, sortDirection: "desc"},
        {key: "lac", label: "lac", sortable: true, sortDirection: "desc"},
        {key: "cid", label: "cid", sortable: true, sortDirection: "desc"},
        {key: "imsi", label: "imsi", sortable: true, sortDirection: "desc"},
        {key: "lat_lon", label: "lat_lon", sortable: true, sortDirection: "desc"},
        {key: "radio", label: "radio", sortable: true, sortDirection: "desc"},
        {key: "weight", label: "weight", sortable: true, sortDirection: "desc"},
        {key: "date", label: "date", sortable: true, sortDirection: "desc"},
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      fromPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: "date",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      filterOn: [],

      periodOption: "Current",
      periodOptions: ["Current", "Daily", "Monthly", "Yearly"],
      isImeiData: false,
      selectedIMSI: [],
      lmeiData: null,
	    showBands: false,
      startTime: "00:00",
      endTime: "23:59",
      dailyDate: new Date().toISOString().substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
      imsiSearch: "",
      rowLimit: 5,
      rowLimitOptions: [5, 10, 15, 20],
      imsi: "",
      loadingStatus: false,
      mapLoading: false,
      isAdminUser: false,
      isPortalAdminUser: false,
      isReadOnlyUser: true, //default setting is readonly

    };
  },
  methods: {

    getTotalRows() {
      if (this.perPage > this.totalRows) {
        this.fromPage = this.totalRows;
      } else {
        this.fromPage = this.perPage;
      }
    },

    changePageOption(page) {
      this.getTotalRows();
    },

    startPage() {
      return pagination.startPageFunc(this.currentPage, this.perPage);
    },

    lastPage() {
      return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async submitSearch(event) {

      if (event) {
        event.preventDefault();
      }

      try {
        this.loadingStatus = true;

        this.localResetData();

        // Fetch location data and update locationCheckTableData
        await this.getDataVolumeByRegion();

        // Deactivate loading status after all async operations are done
        this.loadingStatus = false;

      } catch (error) {
        console.error(error);
        // Deactivate loading status in case of error
        this.loadingStatus = false;
      }
    },

    async getDataVolumeByRegion() {
      this.mapLoading = true;
      this.isImeiData = false;

      const imsi = this.imsiSearch.trim();
      const period = this.periodOption.trim().toLowerCase();

      await troubleshootingService.getDataVolumeSummaryByRegion(imsi, period).then(response => {
        if (response) {
          this.locationCheckTableData = response.message;
          this.totalRows = this.locationCheckTableData.length;
          this.loadMap();
        } else {
          this.loadingStatus = false;
          if (!errorCheck || !failCheck) this.$toast.error("Error retrieving location data.");
          else this.$toast.info("No location data found for IMSI " + this.imsiSearch);
        }

      });

      if (imsi.length==15) this.getlmeiDataByIMSI(imsi);
      else this.isImeiData=false;

    },

    async loadMap() {

      Vue.nextTick(() => {
        this.mapLoading = true
        try {
          let configData = configDirective.getConfigData();
          let bound = new google.maps.LatLngBounds();

          // Use the latitude and longitude from the selected IMSI data
          let selectedLatLon = this.selectedIMSI && this.selectedIMSI.lat_lon ? this.selectedIMSI.lat_lon.split(",") : null;
          let map_center = selectedLatLon || configData["site-settings"]["map_center"].split(",");
          let center = new google.maps.LatLng(map_center[0], map_center[1], true);
          let zoom = configData["site-settings"]["map_zoom"] ? configData["site-settings"]["map_zoom"] : 3;

          const map = new google.maps.Map(document.getElementById("map"), {
            center: center,
            zoom: zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
          });

          if (this.locationCheckTableData.length > 0 && !this.isImeiData) {
            for (let i = 0; i < this.locationCheckTableData.length; i++) {
              let value = this.locationCheckTableData[i];
              if (value != null) {
                this.addMarker(value, false, map, bound);
                
              }
            }
          } else {
            this.addMarker(this.selectedIMSI, false, map, bound);
          }

          // Set map center and zoom to fit all markers
          google.maps.event.addListener(map, "zoom_changed", function () {
            const zoomChangeBoundsListener = google.maps.event.addListener(
                map,
                "bounds_changed",
                function (event) {
                  if (this.getZoom() > 15 && this.initialZoom == true) {
                    this.setZoom(15);
                    this.initialZoom = false;
                  }
                  google.maps.event.removeListener(zoomChangeBoundsListener);
                }
            );
          });
          map.initialZoom = true;
          map.fitBounds(bound);
        } catch (error) {
          console.error("Error initializing map:", error);
        } finally {
          setTimeout(() => {
            this.mapLoading = false;
          }, 1000);
        }
      });
    },

    addMarker(param, isfirst, map, bounds) {
      let icon_3green = "https://i.imgur.com/vSpGkBd.png";
      let icon_4green = "https://i.imgur.com/8jLOZnY.png";
      let icon_3yellow = "https://i.imgur.com/SU1eH1v.png";
      let icon_4yellow = "https://i.imgur.com/theJhNx.png";
      let icon_cgreen = "https://i.imgur.com/CM5c7BE.png";
      let icon_cyellow = "https://i.imgur.com/2eE096C.png";
      let sel_icon = "";

      if (param.connectiontype == "3G" && isfirst == true) {
        //green triangle
        sel_icon = icon_3green;
      } else if (param.connectiontype == "3G" && isfirst == false) {
        // yellow triangle
        sel_icon = icon_3yellow;
      } else if (param.connectiontype == "LTE" && isfirst == true) {
        //green square
        sel_icon = icon_4green;
      } else if (param.connectiontype == "LTE" && isfirst == false) {
        // yellow square
        sel_icon = icon_4yellow;
      } else {
        if (isfirst == true) sel_icon = icon_cgreen;
        else sel_icon = icon_cyellow;
      }

    //   console.log("param:", param)

      let imsi = param.imsi ? param.imsi : "NO DATA";
      let authDate = param.date ? param.date : "NO DATA";
      let connectiontype = param.radio ? param.radio : "Unknown";
      let contentString =
          '<div id="content">' +
          '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Auth Date: </span> ' +
          authDate +
          "</p>" +
          '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">IMSI: </span> ' +
          imsi +
          "</p>" +
          '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
          connectiontype +
          "</p>" +
          "</div>";

      let infowindow = new google.maps.InfoWindow({
        content: contentString,
      });

      let lat = param.lat ? param.lat : 0;
      let lon = param.lon ? param.lon : 0;

      if (param.lat_lon) {
        let lat_lon = param.lat_lon.split(",");
        lat = lat_lon[0];
        lon = lat_lon[1];
      }

      let marker = new google.maps.Marker({
        position: {
          lat: parseFloat(lat),
          lng: parseFloat(lon),
        },

        map: map,
        title: "Point",
        icon: sel_icon,
      });
      marker.addListener("click", function () {
        infowindow.open(map, marker);
      });
      bounds.extend(marker.position);
      map.fitBounds(bounds);
      let markercount = this.locationCheckTableData;
      if (markercount[param.connectiontype] == null) markercount[param.connectiontype] = 1;
      else markercount[param.connectiontype] += 1;

      var ct = "";
      for (var i in markercount) {
        ct += i + "(" + markercount[i] + "), ";
      }
    },

    localResetData() {
      this.imsi = "";
      this.iccid = "";
      this.operatingSystem = "Unknown";
      this.bands = "Unknown";
      this.phoneBrand = "Unknown";
      this.manufacturer = "Unknown";
      this.phoneModel = "Unknown";
      this.phoneName = "Unknown";
      this.rat = "Unknown";
      this.locationCheckTableData = [];
    },

    async getlmeiDataByIMSI(imsi) {
      // Activate loading status before async operation starts
      this.loadingStatus = true;
      try {
        if (imsi) {
          const res = await searchDetailService.getlmeiDataByIMSI(imsi);

			let lmeiData = [];
			for (let key in res) {
				if (key === 'rat') continue;
				let item = {
					field: key.toUpperCase(),
					value: res[key]
				};
				lmeiData.push(item);
			}
		  this.lmeiData = lmeiData;
          this.isImeiData = true;
        } else {
          this.isImeiData = false;
        }
      } catch (error) {
        console.log("Cannot fetch Data for IMSI: ", imsi);
      } finally {
        // Deactivate loading status after async operation is done
        this.loadingStatus = false;
      }
    },

    async updateSelectedIMSI(item) {
      //console.log('selected item:',item);
      this.selectedIMSI = item
      await this.getlmeiDataByIMSI(item.imsi);
      this.loadMap();
    },
  }
};
</script>
